module.exports = __webpack_public_path__ + "static/media/work1.4.4a905c89.webp";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/home/work1.4.webp
// module id = 523
// module chunks = 4